import { render, staticRenderFns } from "./DefaultMenu.vue?vue&type=template&id=0dd68180&scoped=true"
import script from "./DefaultMenu.vue?vue&type=script&lang=js"
export * from "./DefaultMenu.vue?vue&type=script&lang=js"
import style0 from "./DefaultMenu.vue?vue&type=style&index=0&id=0dd68180&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd68180",
  null
  
)

export default component.exports